import { ChannelList } from "../../../../Data/Data";


function ResultSearchChannel({ text, clickHandler }) {
    return (
        <>
            {text &&
                <div className="absolute bg-white text-right max-h-56 overflow-auto pt-1 top-10 left-0 border border-slate-200 w-full">
                    {ChannelList.filter(value => {
                        if (text === "") {
                            return value;
                        } else if (value.name.toLowerCase().includes(text.toLowerCase())) {
                            return value
                        }
                    }).map((item, index) => {
                        return (
                            <button onClick={() => clickHandler(item.name)}
                                className="border-b border-slate-200 pr-4 p-1 
                                                flex w-full justify-end
                                                hover:bg-indigo-700 hover:text-white"
                            >
                                <p>{item.name}</p>
                            </button>
                        )
                    })}
                </div>
            }
        </>
    )
}
export default ResultSearchChannel;